import HeaderNav from "@/layouts/HeaderNav";
import React, { useEffect, useState } from "react";
import PaymentsTable from "./PaymentsTable";
import { Payment, Transaction } from "./interface";
import FormModal from "@/components/modals/FormModal";
import StripePaymentForm from "./StripePaymentForm";
import StripeBTCForm from "./StripeBTCForm";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import TransactionTable from "./TransactionTable";
import DatePicker from "react-datepicker";
import { date } from "yup";
import { eachDayOfInterval, isWithinInterval } from "date-fns";
import { format } from "date-fns";
import { parseISO } from "date-fns";
import useLoading from "@/hooks/useLoading";
import { Loader } from "@thdinc/hpf-shared";

export const PaymentsPage = () => {
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { getPaymentsApi, postPaymentApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const [paymentList, setPamentList] = useState<Payment[]>([]);
  const [filteredPayments, setFilteredPayments] = useState<Payment[]>([]);
  const [currData, setCurrData] = useState<Payment>();
  const [rerender, setRerender] = useState(false);
  const renderFun = () => {
    setRerender(!rerender);
  };
  useEffect(() => {
    const getPayments = async () => {
      try {
        startLoading();
        const res = await GET(getPaymentsApi, refreshToken);
        setPamentList(res.data);
        setFilteredPayments(res.data)
        // setPamentList(res.data)
      } catch (error) {
        console.log(error);
      } finally {
        stopLoading();
      }
    };
    getPayments();
  }, [rerender]);
  const selectCurrentPayment = (paymentId: string) => {
    const cur = paymentList.find((i: Payment) => i.id === paymentId);
    setCurrData(cur);
  };

  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setCurrTab("HOWS")
    setIsModalOpen(false);
  };
  // transaction modal
  const [tranModal, setTranModal] = useState(false);
  const openTransModal = () => setTranModal(true);
  const closeTransModal = () => {
    setTranModal(false);
  };

  // --

  // tabs
  type Tab = "HOWS" | "BTC";
  const [currTab, setCurrTab] = useState<Tab>("HOWS");
  const changeTab = (tab: Tab) => {
    setCurrTab(tab);
  };
  // --
  // search functiionality
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const searchedAndFiltered = filteredPayments.filter((item: Payment) => {
    const { business_name } = item;
    const customerName = `${item.first_name} ${item.last_name}`.toLowerCase();
    const search = searchQuery.toLowerCase();
    return business_name.toLocaleLowerCase().includes(search) || customerName.includes(search);
  });

  // Range Functionality
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;
  const dateRangeFun = (update: [Date | null, Date | null]) => {
    setDateRange(update);
    const [start, end] = update;

    if (start && end) {
      setFilteredPayments(filterEventsByDateRange(paymentList, start, end));
    } else if (!start && !end) {
      setFilteredPayments(paymentList);
    }
  };

  // Function that returns an array of date strings in a specified range
  function filterEventsByDateRange(
    events: Payment[],
    startDate: Date,
    endDate: Date
  ): Payment[] {
    return events.filter((event) => {
      const eventDate = parseISO(event.event_date); // Convert to Date object
      return isWithinInterval(eventDate, { start: startDate, end: endDate });
    });
  }
  return (
    <div>
      <HeaderNav>
        <div className="flex justify-between md:items-center items-start flex-wrap md:flex-row flex-col ">
          <h1 className="md:text-3xl text-xl text-gray-800 font-semibold ">
            Payments
          </h1>
          <div className="flex items-center gap-4 sm:flex-row flex-col w-full md:w-fit mt-4 md:mt-0 ">
            <input
              type="text"
              placeholder="Search Customer or Business Name"
              onChange={handleSearch}
              className=" md:min-w-80 w-full px-4 py-3 bg-white rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              name=""
            />
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              className=" cursor-pointer md:w-56 w-full px-4 py-3 bg-white rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              onChange={dateRangeFun}
              isClearable={true}
              placeholderText="Date Range"
            />
          </div>
        </div>
      </HeaderNav>
      {isLoading ? (
        <Loader color="bg-red-500" />
      ) : searchedAndFiltered.length > 0 ? (
        <PaymentsTable
          payments={searchedAndFiltered}
          selectCurrentPayment={selectCurrentPayment}
          openModal={openModal}
          openTransModal={openTransModal}
          // selectCurrentTrans={selectCurrentTrans}
        />
      ) : (
        <p className="text-center">No Item Found</p>
      )}
      <FormModal
        overflow="overflow-hidden "
        modalTitle={
          `${currData?.first_name} ${currData?.last_name} ` as string | "Name"
        }
        isOpen={isModalOpen}
        onClose={closeModal}
        width="lg:w-3/6 md:w-5/6 w-full"
      >
        {/* TABs */}
        <div className="mt-3 mb-10 flex justify-center">
          <ul className="  flex   font-medium text-center text-gray-500  border-gray-400  bg-p-gray rounded-full w-fit p-1 mb-2 md:mb-0">
            <button
              onClick={() => changeTab("HOWS")}
              aria-current="page"
              className={`inline-block px-5 py-2      ${
                currTab === "HOWS" ? "text-white   bg-black rounded-full " : ""
              }`}
            >
              HOWS
            </button>
            <li className="me-2 cursor-pointer">
              <div
                onClick={() => changeTab("BTC")}
                className={`inline-block px-5 py-2 ${
                  currTab === "BTC" ? "text-white   bg-black rounded-full " : ""
                } `}
              >
                BTC
              </div>
            </li>
          </ul>
        </div>
        {currData && (
          <div>
            {currTab === "HOWS" ? (
              <StripePaymentForm
                paymentInfo={currData}
                closeModal={closeModal}
                renderFun={renderFun}
              />
            ) : (
              <StripeBTCForm
                paymentInfo={currData}
                closeModal={closeModal}
                renderFun={renderFun}
              />
            )}
          </div>
        )}
      </FormModal>

      {/* Transaction Table */}
      <FormModal
        overflow="overflow-hidden "
        modalTitle="Charges History"
        isOpen={tranModal}
        onClose={closeTransModal}
        width="lg:w-5/6 md:w-5/6 w-full"
      >
        {currData && <TransactionTable bookingId={currData?.id} />}
      </FormModal>
    </div>
  );
};
